<div class="ktag" [class.ktag--disabled]="disabled">
  <label *ngIf="label" class="ktag__label">{{ label }}</label>

  <mat-select class="ktag__select" [multiple]="true" [value]="value" [disabled]="disabled"
    [placeholder]="placeholder" [disableOptionCentering]="true" panelClass="ktag-panel"
    (selectionChange)="onSelect($event)" (openedChange)="onPanelToggle($event)" (blur)="onTouched()">
    <!-- Always show the placeholder in the field; the selection lives in the chips below. -->
    <mat-select-trigger>
      <span class="ktag__placeholder">{{ placeholder }}</span>
    </mat-select-trigger>

    <!-- In-panel search — filters by group (facility/unit) and label (system). -->
    <mat-option *ngIf="searchable" class="ktag__search-option" [disabled]="true">
      <ngx-mat-select-search [ngModel]="searchQuery" (ngModelChange)="onSearch($event)"
        [placeholderLabel]="searchPlaceholder" [noEntriesFoundLabel]="noResultsText"></ngx-mat-select-search>
    </mat-option>

    <ng-container *ngIf="hasGroups">
      <mat-optgroup *ngFor="let group of filteredGroups; trackBy: trackByGroup" [label]="group.name">
        <mat-option *ngFor="let opt of group.options; trackBy: trackByOption" [value]="opt.value"
          [disabled]="opt.disabled">
          {{ opt.label }}
        </mat-option>
      </mat-optgroup>
    </ng-container>

    <ng-container *ngIf="!hasGroups">
      <mat-option *ngFor="let opt of filteredGroups[0]?.options; trackBy: trackByOption" [value]="opt.value"
        [disabled]="opt.disabled">
        {{ opt.label }}
      </mat-option>
    </ng-container>
  </mat-select>

  <div class="ktag__chips" *ngIf="value?.length">
    <span class="ktag__chip" *ngFor="let v of value">
      <span class="ktag__chip-text">{{ optionLabel(v) }}</span>
      <mat-icon class="ktag__chip-close" (click)="remove(v)">close</mat-icon>
    </span>
  </div>

  <div class="ktag__hint" *ngIf="hint">{{ hint }}</div>
</div>
